import React from 'react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/**
 * Active-filters row for a list toolbar: result count + one chip per active
 * filter (removable) + a "clear all" action. Renders nothing when there are
 * no active filters.
 */
export default function ActiveFiltersBar({ chips = [], resultsLabel, clearLabel, onClearAll }) {
  if (chips.length === 0) return null;

  return (
    <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap" sx={{ px: 2, py: 1.5 }}>
      {resultsLabel && (
        <Typography variant="body2" color="text.secondary">
          {resultsLabel}
        </Typography>
      )}
      {chips.map((chip) => (
        <Chip key={chip.key} label={chip.label} onDelete={chip.onDelete} size="small" />
      ))}
      <Button size="small" color="error" startIcon={<DeleteOutlineIcon fontSize="small" />} onClick={onClearAll}>
        {clearLabel}
      </Button>
    </Stack>
  );
}
